import {
  Table,
  TableHead,
  TableBody,
  TableHeader,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default WaitForCallbackExpectedFieldTable;

function WaitForCallbackExpectedFieldTable(props) {
  const { expectedFields, onEditExpectedField, onRemoveExpectedField } = props;

  if (expectedFields.length === 0) return null;

  return (
    <Table>
      <TableHead>
        <TableHeader>Field</TableHeader>
        <TableHeader>Type</TableHeader>
        <TableHeader>Action</TableHeader>
      </TableHead>
      <TableBody>
        {expectedFields.map((expectedField, idx) => {
          const handleEdit = () => {
            onEditExpectedField(expectedField, idx);
          };

          const handleRemove = () => {
            onRemoveExpectedField(idx);
          };

          return (
            <TableRow key={idx}>
              <TableCell>
                <p className="text-sm">{expectedField.fieldName}</p>
              </TableCell>
              <TableCell>
                <p className="text-sm">{expectedField.fieldType}</p>
              </TableCell>
              <TableCell>
                <div className="flex items-center gap-x-2">
                  <Button
                    plain
                    onClick={handleEdit}
                  >
                    <PencilIcon />
                  </Button>
                  <Button
                    plain
                    onClick={handleRemove}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
